import { NotificationLayersCopyData } from "@iventis/domain-model/model/notificationLayersCopyData";
import { NotificationLayersImportData } from "@iventis/domain-model/model/notificationLayersImportData";
import { NotificationMapExportData } from "@iventis/domain-model/model/notificationMapExportData";
import { NotificationMapsCopyData } from "@iventis/domain-model/model/notificationMapsCopyData";
import { NotificationResourceType } from "@iventis/domain-model/model/notificationResourceType";
import { UserNotification } from "@iventis/domain-model/model/userNotification";

export interface MapExportNotification extends UserNotification<NotificationMapExportData> {
    resourceType: NotificationResourceType.MapExport;
}

export interface LayersImportNotification extends UserNotification<NotificationLayersImportData> {
    resourceType: NotificationResourceType.LayersImport;
    resourceData: NotificationLayersImportData;
}

export interface LayersCopyNotification extends UserNotification<NotificationLayersCopyData> {
    resourceType: NotificationResourceType.LayersCopy;
    resourceData: NotificationLayersCopyData;
}

export interface MapsCopyNotification extends UserNotification<NotificationMapsCopyData> {
    resourceType: NotificationResourceType.MapsCopy;
    resourceData: NotificationMapsCopyData;
}

export type UserNotificationUnion = MapExportNotification | LayersImportNotification | LayersCopyNotification | MapsCopyNotification;

export type UserNotificationBaseProps = {
    notification: UserNotificationUnion;
    onClick: () => void;
};
